/* eslint-disable max-len */
// Dependencies
import React, {useRef} from 'react'
import {connect} from 'react-redux'
import {AudioVisualizer} from 'react-audio-visualize'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesAudioRender from '../styles/AudioRender.module.css'

// Components

function AudioRender(props) {
  const audioVisRef = useRef(null)

  return (
    <div
      className={stylesAudioRender['audio-render']}
    >
      {props.file && <AudioVisualizer
        ref={audioVisRef}
        blob={props.file}
        width={500}
        height={80}
        barColor='#d7f0f4'
      />}
      <audio
        className={stylesAudioRender['audio-player']}
        controls
        controlsList="nodownload noplaybackrate nofullscreen"
        src={URL.createObjectURL(props.file)}
        type={props.file?.type}
      />
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
})

export default connect(
    mapStateToProps,
    {},
)(AudioRender)
